import React from "react";

type ReplyAllIconProps = {
  className?: string;
  onClick?: () => void;
  size?: string;
  color?: string;
};

const ReplyAllIcon = ({
  size = "16",
  className,
  onClick,
  color = '#373F51',
}: ReplyAllIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M5.75586 12.2067H11.0892C12.9292 12.2067 14.4225 10.7134 14.4225 8.87337C14.4225 7.03337 12.9292 5.54004 11.0892 5.54004H3.75586"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.2887 7.20655L3.58203 5.49988L5.2887 3.79321"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.28674 7.20655L0.580078 5.49988L2.28674 3.79321"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReplyAllIcon;
